/* global GIF */
import React, { Component, Fragment } from 'react';
import gifFrames from 'gif-frames';
import async from 'async';
import '../Modal/Modal.scss';
import './VIPModal.scss';
import { detectMobile } from '../../_helpers.js';

class VIPModal extends Component { 
    constructor(props) {
        super(props);   
        this.state = {
            text : 'Add your own custom text',
            done : true
        }    
    }
    componentDidMount () {
        // ready
        let logo = new Image();
            logo.src = '/assets/img/logo-klue.svg';
            
        this.setState({
            width : document.getElementsByClassName('VIPModal--gif')[0].offsetWidth,
            height : document.getElementsByClassName('VIPModal--gif')[0].offsetHeight,
            logo : logo
        })
    }
    generateThumbnail = (frame) => {     
        //generate thumbnail URL data
        const _width = this.state.width,
            _height = this.state.height;    
        const _canvas = document.createElement('canvas');
            _canvas.width = _width;
            _canvas.height = _height;
        const _context = _canvas.getContext('2d');
            _context.drawImage(frame, 0, 0, _width, _height);
    
           // _context.drawImage(this.state.logo, _width - 450, _height - 300, 450, 300);
            
            _context.font = `bold 30px sans-serif`;
            _context.textAlign = 'center';
            _context.textBaseline = 'middle';
            _context.lineWidth = 3;
            _context.strokeStyle = '#FC585F';
            _context.strokeText(this.state.text, _width/2, _height-40);
            
            _context.fillStyle = '#FC585F';
            _context.fillText(this.state.text, (_width/2)+4, _height-43);
            
            _context.fillStyle = '#fff69d';
            _context.fillText(this.state.text, _width/2, _height-40);
        
            _context.drawImage(this.state.logo, 15, 15, 36, 15);
            
            
        
        let _dataURL = _canvas.toDataURL();;
        const img = document.createElement('img');
        img.setAttribute('src', _dataURL);
        img.setAttribute('class', 'VIPModal--source');
        
        //append img in container div
        document.getElementsByClassName('VIPModal--thumbnails')[0].appendChild(img);        
    }
    handleGIFImage = () => {        
        let _imgRender = document.querySelectorAll('.VIPModal--gif')[0];

        var gif = new GIF({
            workerScript : '/assets/js/gif.worker.js',
            workers: 3,
            quality: 4,
            //dither: 'FloydSteinberg',
            width: this.state.width,
            height: this.state.height
        });
        
        const loadImage = function(src, callback) {
            const img = new Image();
            img.onload = () => callback(null, img);
            img.onerror = () => callback(new Error(`Could load ${ src }`));
            return img.src = src;
        };
        
        let _images = Object.values(document.querySelectorAll('.VIPModal--source')).map(image => image.src),
            _delay = 2;
     
        async.map(_images, loadImage, function(error, images) {
            if (error !== null) { 
                throw error; 
            }
            for (let image of Array.from(images)) { 
                gif.addFrame(image, {delay: _delay, copy: true}); 
            }
            return gif.render();
        });
        
        gif.on('finished', function(blob) {
            _imgRender.src = URL.createObjectURL(blob);
            document.getElementsByClassName('VIPModal--thumbnails')[0].innerHTML = ""; // remove the thumbs
            this.setState({
                done : true // completed the whole shabang-bang
            })
        }.bind(this));
    }
    renderFrames = () => {
        gifFrames({ url: `/assets/img/gifs/${this.props.gif}.gif`, frames: 'all', cumulative: true, outputType: 'canvas' })
        .then(function (frameData) {
            
            this.setState({
                frameBG : frameData[0].getImage()
            })
            
            let _chk = 0;
            
            frameData.forEach(function (frame, index) {
                this.generateThumbnail(frame.getImage());
                _chk++
                if (_chk >= frameData.length) {
                    this.handleGIFImage();   
                }
            }.bind(this));
            
        }.bind(this)).catch(console.error.bind(console));
    }
    handleKeyPress = (e) => {
        var keyCode = e.keyCode || e.which;
        if (keyCode == '13'){
            // Enter pressed
            this.handleClickStart();
        }
    }
    handleText = (e) => {
        this.setState({
            text : e.target.value
        })
    }
    handleClickStart = () => {
        // go go go 
        this.setState({
            width : document.getElementsByClassName('VIPModal--gif')[0].offsetWidth,
            height : document.getElementsByClassName('VIPModal--gif')[0].offsetHeight,
            done : false
        })
        
        this.renderFrames();
    }
    render () {
        return (
            <div class="Modal">
                <div>
                    <div class="VIPModal">
                        { this.props.gif && 
                            <div>
                                <img class="VIPModal--gif" src={ `/assets/img/gifs/${this.props.gif}.gif` } alt={ `${this.props.gif}` } /> 
                                { this.state.done &&
                                    <div class="Modal--message">
                                        <div class="Modal--grid">
                                            <input
                                                autofocus="true"
                                                maxlength="40" 
                                                type="text" 
                                                defaultValue={ this.state.text } 
                                                onChange={ this.handleText } 
                                                onKeyPress={ this.handleKeyPress }
                                            />
                                            <button onClick={ this.handleClickStart }>Go</button>
                                        </div>
                                    </div>
                                }
                                { !this.state.done &&
                                    <div class="Modal--message flash">
                                        Makin&apos; your GIF ... hang on
                                    </div> 
                                }
                                { detectMobile() &&
                                    <p><span>save_alt</span> tap and hold for options</p>
                                }
                                { !detectMobile() &&
                                    <p><span>save_alt</span> right-click and choose an option</p>
                                }
                                
                                <div class="VIPModal--thumbnails"></div>
                            </div>
                        }
                        { this.props.children }
                        <button onClick={ this.props.handleClose }>Close</button>
                    </div>
                </div>
            </div>
        );
    }
}

export default VIPModal;